import React, {Component} from 'react';
import * as messageConstants from '../../shared/messages';
import * as samlConstants from '../../constants/samlConstants';

class DefaultNameId extends Component {

  render() {
    return (
        <div>
          <br/>
          <table>
            <tbody>
            <tr>
              <th className="attribute-name-title">
                {messageConstants.SBA_DEFAULT_NAME_ID_TITLE}
              </th>
              {this.props.defaultSamlNameIdFormatEnum === samlConstants.UNSPECIFIED ?
              <th className="attribute-dropdown-title pl-12">
                {messageConstants.SBA_UNSPECIFIED_NAME_ID_ATTRIBUTE}
              </th> : null}
            </tr>
            <tr>
              <td className="pb-12">
                {this.props.importedMetadata
                && this.props.importedMetadata.samlNameIdFormats[0] ? <select
                    className="form-control nameId-dropdown"
                    value={this.props.defaultSamlNameIdFormatEnum}
                    onChange={this.props.handleUpdateDefaultNameId}>
                  {this.props.importedMetadata.samlNameIdFormats.map(
                      (d) => <option key={d.samlNameIdFormatEnum}
                                     value={d.samlNameIdFormatEnum}>{messageConstants[d.samlNameIdFormatEnum]}</option>)}
                </select> : <select
                    value={this.props.defaultSamlNameIdFormatEnum}
                    className="form-control nameId-dropdown"
                    onChange={this.props.handleUpdateDefaultNameId}>
                  <option
                      value={samlConstants.EMAIL_ADDRESS}>{messageConstants.EMAIL_ADDRESS}</option>
                  <option
                      value={samlConstants.PERSISTENT}>{messageConstants.PERSISTENT}</option>
                  <option
                      value={samlConstants.TRANSIENT}>{messageConstants.TRANSIENT}</option>
                  <option
                      value={samlConstants.UNSPECIFIED}>{messageConstants.UNSPECIFIED}</option>
                  <option
                      value={samlConstants.WINDOWS_DOMAIN_QUALIFIED_NAME}>{messageConstants.WINDOWS_DOMAIN_QUALIFIED_NAME}</option>
                </select>}
              </td>

              {this.props.defaultSamlNameIdFormatEnum === samlConstants.UNSPECIFIED ?
                  <td className="pl-12 pb-12">
                    <select
                        id="unspecifiedNameIdFormatAttributeEnumSelect"
                        value={this.props.unspecifiedNameIdFormatAttributeEnum}
                        className="form-control attributes-dropdown"
                        onChange={this.props.handleUpdateUnspecifiedNameIdFormatAttribute}>
                      <option
                          value={samlConstants.UNSPECIFIED_NAME_ID_EMAIL_ADDRESS}>{messageConstants.UNSPECIFIED_NAME_ID_EMAIL_ADDRESS}</option>
                      <option
                          value={samlConstants.UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME}>{messageConstants.UNSPECIFIED_NAME_ID_USER_PRINCIPAL_NAME}</option>
                      <option
                          value={samlConstants.UNSPECIFIED_NAME_ID_USER_DISPLAY_NAME}>{messageConstants.UNSPECIFIED_NAME_ID_USER_DISPLAY_NAME}</option>
                      {this.props.displaySidOption ?
                          <option
                              value={samlConstants.UNSPECIFIED_NAME_ID_OBJECT_SID}>{messageConstants.UNSPECIFIED_NAME_ID_OBJECT_SID}</option>
                          : null}
                      <option
                          value={samlConstants.UNSPECIFIED_NAME_ID_OBJECT_GUID}>{messageConstants.UNSPECIFIED_NAME_ID_OBJECT_GUID}</option>
                    </select>
                  </td> : null}
            </tr>
            </tbody>
          </table>
        </div>
    );
  }
}

export default DefaultNameId;



// WEBPACK FOOTER //
// ./src/components/AddSAML/DefaultNameId.js